import React, {memo, useCallback} from "react";
import {Box, Button, ButtonGroup, Typography} from "@mui/material";

export const FontSize = memo(({
  fontSize,
  onChangeCallback,
  maxSize,
  precision,
  disabled,
}: {
  fontSize: number;
  onChangeCallback: (newSize: number) => void;
  maxSize?: number;
  precision?: number;
  disabled?: boolean;
}) => {
  precision = precision || 5;
  disabled = disabled || false;
  const disableIncrease = !!(maxSize && fontSize + precision > maxSize);
  const disableDecrease = fontSize - precision < 0;

  const increaseFontSize = useCallback(() => {
    const newFontSize = fontSize + precision;
    onChangeCallback(newFontSize);
  }, [fontSize, precision, onChangeCallback]);

  const decreaseFontSize = useCallback(() => {
    const newFontSize = fontSize - precision;
    onChangeCallback(newFontSize);
  }, [fontSize, precision, onChangeCallback]);


  return (
    <>
      <ButtonGroup variant="contained" color="info" size="medium">
        <Button onClick={decreaseFontSize} disabled={disableDecrease || disabled}>-</Button>
        <Box display="flex" alignItems="center" justifyContent="center" mx={1}>
          <Typography variant="body2">
            {fontSize}
          </Typography>
        </Box>
        <Button onClick={increaseFontSize} disabled={disableIncrease || disabled}>+</Button>
      </ButtonGroup>
    </>
  );
});

export default FontSize;
